import { Injectable, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CommonModule, Location } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { MainComponent } from "./main/main.component";
import { SpeedService } from "./_service/speed.service";
import { PingService } from "./_service/ping.service";
import { DownloadService } from "./_service/download.service";
import { UploadService } from "./_service/upload.service";
import { IpService } from "./_service/ip.service";
import { IspService } from "./_service/isp.service";
import { StoreService } from "./_service/store.service";
import { ServerService } from "./_service/server.service";
import { HelperService } from "./_service/helper.service";
import { APIService } from "./_service/api.service";
import { ISGService } from "./_service/isg.service";
import { NavheaderComponent } from "./navheader/navheader.component";
import { FooterComponent } from "./footer/footer.component";
import { FooterAltComponent } from "./footer-alt/footer-alt.component";
import { SCPrimaryButton } from "./_components/sc-primary-button/sc-primary-button.component";
import { StartButtonComponent } from "./_components/start-button/start-button.component";
import { RetryButtonComponent } from "./_components/retry-button/retry-button.component";
import { MainButtonComponent } from "./_components/main-button/main-button.component";
import { ProviderWidgetComponent } from "./_components/provider-widget/provider-widget.component";
import { ISGWidgetComponent } from "./_components/isg-widget/isg-widget.component";
import { AdWidgetComponent } from "./_components/ad-widget/ad-widget.component";
import { TestComponent } from "./test/test.component";
import { ResultComponent } from "./result/result.component";
import { ChartsComponent } from "./charts/charts.component";
import { ChartsModule } from "ng2-charts";
import { ProgressService } from "./test/progress.service";
import { BarRatingModule } from "ngx-bar-rating";
import { RoundProgressModule } from "angular-svg-round-progressbar";
import { ShareButtonsModule } from "@ngx-share/buttons";
import { CookieService } from "ngx-cookie-service";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { NgxDatatableModule } from "@swimlane/ngx-datatable";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { DeviceDetectorModule } from "ngx-device-detector";

import { HistoryComponent } from "./history/history.component";
import { SettingsComponent } from "./settings/settings.component";
import { AccountComponent } from "./account/account.component";
import { PasswordStrengthComponent } from "./_shared/password-strength/password-strength.component";

import { AlertService } from "./_service/alert.service";
import { AlertComponent } from "./_directives/alert.component";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AuthGuard } from "./_guards/auth.guard";
import { AuthenticationService } from "./_service/authentication.service";
import { LoginComponent } from "./login/login.component";
import { LogoutComponent } from "./logout/logout.component";
import { RegisterComponent } from "./register/register.component";
import { ForgotComponent } from "./forgot/forgot.component";
import { ResetComponent } from "./reset/reset.component";

import { GlobalEventsService } from "./_service/globalevents.service";

import { GeoLocationService } from "./_service/geolocation.service";

import { ChartService } from "./_service/chart.service";

import { CustomDateFormatPipe } from "./_pipes/customdate.pipe";
import { NgSelectModule } from "@ng-select/ng-select";

import { AgmCoreModule } from "@agm/core";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { CollapseModule } from "ngx-bootstrap/collapse";

import { EqualValidator } from "./_validator/equal-validator.directive";

import { TestsChartComponent } from "./_components/tests-chart/tests-chart.component";

import { AffiliateService } from "./_service/affiliate.service";
import { AdsenseModule } from "ng2-adsense";
import { AnalyticsDirective } from "./_directives/analytics.directive";

import { PDFService } from "./_service/pdf.service";
// import { TestsStatusService } from './tests-status.service';

// import localeEn from '@angular/common/locales/en';
// import localeEnExtra from '@angular/common/locales/extra/en';
// import localeFr from '@angular/common/locales/fr';
// import localeDE from '@angular/common/locales/de';
// // other locales...
// // registerLocaleData(localeEn, 'en', localeEnExtra);
// // registerLocaleData(localeFr);
// // registerLocaleData(localeDE);

import { environment } from "../environments/environment";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  if (environment.production) {
    return new TranslateHttpLoader(
      http,
      "https://cf-cdn.speedcheck.org/assets/i18n/",
      ".json"
    );
  } else {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
  }
}

// export function HttpLoaderFactory(http: HttpClient) {
//     return new TranslateHttpLoader(http);
// }

// import { Injectable } from '@angular/core';
// import { Location } from '@angular/common';

// @Injectable()
// export class UnstripTrailingSlashLocation extends Location {
//   public static stripTrailingSlash(url: string): string {
//     return url;
//   }
// }

// Location.stripTrailingSlash = UnstripTrailingSlashLocation.stripTrailingSlash;

// Location.stripTrailingSlash = function stripTrailingSlashNew(url: string) {
//     console.log(url)
//   return url;
// };

@Injectable()
export class UnstripTrailingSlashLocation extends Location {
  public static stripTrailingSlash(url: string): string {
    return url;
  }
}

Location.stripTrailingSlash = UnstripTrailingSlashLocation.stripTrailingSlash;

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    CommonModule,
    HttpClientModule,
    BarRatingModule,
    ChartsModule,
    BrowserAnimationsModule,
    RoundProgressModule,
    NgxDatatableModule,
    ShareButtonsModule,
    DeviceDetectorModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgbModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyBOsUlynKgrKzuAlgXiTX7i4NFitSCF3WU",
    }),
    NgSelectModule,
    CollapseModule,
    BsDatepickerModule.forRoot(),
    AdsenseModule.forRoot({
      adClient: "ca-pub-2468526354430798",
    }),
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    LogoutComponent,
    RegisterComponent,
    ForgotComponent,
    ResetComponent,
    AlertComponent,
    MainComponent,
    HistoryComponent,
    SettingsComponent,
    AccountComponent,
    NavheaderComponent,
    FooterComponent,
    FooterAltComponent,
    SCPrimaryButton,
    StartButtonComponent,
    RetryButtonComponent,
    MainButtonComponent,
    ProviderWidgetComponent,
    ISGWidgetComponent,
    AdWidgetComponent,
    TestComponent,
    ResultComponent,
    ChartsComponent,
    CustomDateFormatPipe,
    EqualValidator,
    TestsChartComponent,
    AnalyticsDirective,
    PasswordStrengthComponent,
  ],
  providers: [
    AuthGuard,
    AuthenticationService,
    AlertService,
    SpeedService,
    IpService,
    IspService,
    PingService,
    DownloadService,
    UploadService,
    StoreService,
    ProgressService,
    ServerService,
    HelperService,
    APIService,
    CookieService,
    GlobalEventsService,
    ChartService,
    GeoLocationService,
    AffiliateService,
    ISGService,
    PDFService,
    // TestsStatusService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
